import { useLocation } from 'react-router-dom';
import { BannerLogin } from './left-banner-login';
import { BannerGetStarted } from './left-banner-get-started';
import { BannerCompanyOverview } from './left-banner-company-overview';
import { BannerOkrs } from './left-banner-okrs';
import { useAuthenticator } from '@aws-amplify/ui-react';

function LeftBanner() {
  const location = useLocation();
  const { user } = useAuthenticator((context) => [context.user]);

  if (!user) return <BannerLogin />;

  switch (location.pathname) {
    case '/':
      return <BannerLogin />;
    case '/get-started':
      return <BannerGetStarted />;
    case '/company-overview':
      return <BannerCompanyOverview />;
    case '/okrs':
      return <BannerOkrs />;
  }

  return null;
}

export { LeftBanner };
